import { useEffect, useState } from 'react'
import { Form, Button, Modal } from 'react-bootstrap'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'
import CustomCloseButton from '../../Button/CustomCloseButton'

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

function ModalEditBuItem({ show, onHide, detail, refreshData, ...props }) {
  const [buOptions, setBuOptions] = useState([])
  const [selectedBuId, setSelectedBuId] = useState('')
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (show) {
      fetchBusinessUnits()
      setSelectedBuId(detail?.bu_id || '')
    }
  }, [show, detail])

  const fetchBusinessUnits = async () => {
    setLoading(true)
    try {
      const res = await api.get('master/business-units/all')
      setBuOptions(res.data.data || [])
    } catch (err) {
      const errMsg =
        err?.response?.data?.errors?.message || 'Failed to fetch Business Units'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaving(true)
    try {
      const payload = { bu_id: selectedBuId || null }
      const res = await api.patch(
        `/master/items/${detail.id}/business-unit`,
        payload
      )
      if (res.data.success) {
        Common.showPopUpSuccessMessage('Business Unit updated successfully')
        onHide()
        refreshData()
      }
    } catch (err) {
      const errMsg =
        err?.response?.data?.errors?.message || 'Failed to update Business Unit'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal show={show} onHide={onHide} centered {...props}>
      <Modal.Header closeButton>
        <Modal.Title>Update Business Unit</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {loading ? (
            <p className="text-center">Loading Business Units...</p>
          ) : (
            <Form.Group className="mb-3">
              <Form.Label
                className="fw-bold text-muted text-uppercase"
                style={{ fontSize: '13px', letterSpacing: '0.5px' }}
              >
                Business Unit
              </Form.Label>
              <Form.Select
                value={selectedBuId}
                onChange={(e) => setSelectedBuId(e.target.value)}
                style={FormControlStyle}
              >
                <option value="">-- Select Business Unit --</option>
                {buOptions.map((bu) => (
                  <option key={bu.id} value={bu.id}>
                    {bu.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer>
          <CustomCloseButton text="Cancel" onClick={onHide} />
          <Button
            type="submit"
            variant="warning"
            className="text-white"
            disabled={saving || loading}
          >
            {saving ? 'Saving...' : 'Save'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default ModalEditBuItem
